import React, { useState } from 'react'
import { Dropdown, Menu } from 'antd'

import { AiOutlineDown } from 'react-icons/ai'

import Receive from '../../../components/reusable/receive'

import NewPaymentMethod from '../../../components/drawers/newPaymentMethod'
import PaymentMethod from '../../../components/drawers/paymentMethod'

import { stringifyDate, useListData, usePet, useToggle } from '../../../modules'

const PaymentMethods = () => {
    const [selected, setSelected] = useState()
    const [string, setString] = useState('')

    const [newPayMethodModal, toggleNewPayMethodModal] = useToggle()
    const [payMethodModal, togglePayMethodModal] = useToggle()

    const select = mth => {
        setSelected(mth)
        togglePayMethodModal()
    }
    
    const [
        { loading, error, fetch }, 
        { list: methods }, 
        { navigate, Paginate, page = 1, limit = 10 }
    ] = useListData('paymentMethods', { string, type: 'regular' } , { notify: true, manual: false }, 'methods')

    const refresh = () => {
        navigate(1)
        fetch()
    }

    const search = str => {
        setString(str)
        refresh()
    }
    
    const onComplete = ({ data }, notif, ops) => {
        notif(`Account has been ${selected?.active ? 'deactivated' : 'activated' }`, ops('success'))        
        refresh()
    }

    const [, execute] = usePet('togglePaymentMethodActiveStatus', { id: selected?._id }, { notify: true, callback: onComplete, manual: true })

    const toggleActive = mth => {
        setSelected(mth)
        execute()        
    }

    return (
        <div className="px-4 sm:px-6 lg:px-8 py-8 w-full mx-auto">
            {
                newPayMethodModal &&
                <NewPaymentMethod
                    onPerform={ fetch }
                    toggle={ toggleNewPayMethodModal }
                    visible={ newPayMethodModal } />
            }
            
            {
                payMethodModal &&
                <PaymentMethod
                    onPerform={ fetch }
                    method={ selected }
                    toggle={ togglePayMethodModal }
                    visible={ payMethodModal } />
            }
            <div className="sm:flex sm:justify-between sm:items-center mb-8">
                <input
                    onChange={e => search(e.target.value)}
                    className="appearance-none block max-w-4xl bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white"
                    id="grid-search"
                    type="text"
                    placeholder="Search by Name" />
                <div className="grid grid-flow-col sm:auto-cols-max justify-start sm:justify-end gap-2">
                    <button onClick={ toggleNewPayMethodModal } className="btn hisani-btn-green-light text-white">
                        <svg className="w-4 h-4 fill-current opacity-50 flex-shrink-0" viewBox="0 0 16 16">
                            <path d="M15 7H9V1c0-.6-.4-1-1-1S7 .4 7 1v6H1c-.6 0-1 .4-1 1s.4 1 1 1h6v6c0 .6.4 1 1 1s1-.4 1-1V9h6c.6 0 1-.4 1-1s-.4-1-1-1z" />
                        </svg>
                        <span className="hidden xs:block ml-2">Add New Payment Method</span>
                    </button>
                </div>
            </div>
            <div className="col-span-full xl:col-span-8 bg-white shadow-lg rounded-sm border border-gray-200">
                <header className="px-5 py-4 border-b border-gray-100 flex justify-between items-center">
                    <h2 className="font-semibold text-gray-800">Payment Methods</h2>
                </header>
                <div className="p-3">

                    {/* Table */}
                    <div className="overflow-x-auto">
                        <Receive
                            error={error}
                            loading={loading}
                            progress>
                            {
                                methods.length > 0 ?
                                    <table className="table-auto w-full">
                                        {/* Table header */}
                                        <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                                            <tr>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center">No</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-left">Name</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center">Status</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center">Account</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center"></div>
                                                </th>
                                            </tr>
                                        </thead>
                                        {/* Table body */}
                                        <tbody className="text-sm font-medium divide-y divide-gray-100">
                                            {/* Row */}
                                            {
                                                methods.map((method, key) =>
                                                    <tr>
                                                        <td className="p-2">
                                                            <div className="text-center">{((page - 1) * limit) + key + 1}.</div>
                                                        </td>
                                                        <td className="p-2">
                                                            <div className="">{ method.name }</div>
                                                        </td>
                                                        <td className="p-2">
                                                            <div className={ `text-center ${ method.active ? 'text-green-500' : 'text-gray-700' }` }>{ method.active ? 'Active' : 'Inactive' }</div>
                                                        </td>
                                                        <td className="p-2">
                                                            <div className="text-center">{ method?.account?.name }</div>
                                                        </td>
                                                        <td className="p-2 text-center">
                                                            <Dropdown
                                                                overlay={
                                                                    <Menu>
                                                                        <Menu.Item onClick={ () => select(method) }>View</Menu.Item>
                                                                        <Menu.Item onClick={ () => toggleActive(method) }>{ method.active ? 'Deactivate' : 'Activate' }</Menu.Item>
                                                                    </Menu>
                                                                }>
                                                                <a className="ant-dropdown-link flex items-center h-10" onClick={e => e.preventDefault()}><span className="mr-2">Actions</span> <AiOutlineDown /></a>
                                                            </Dropdown>
                                                        </td>
                                                    </tr>
                                                )
                                            }
                                        </tbody>
                                    </table>
                                :
                                    <div className="w-full h-16 flex items-center justify-center">
                                        <p className="font-semibold text-base">Please click above to add a new payment method</p>
                                    </div>
                            }
                        </Receive>
                        {Paginate}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PaymentMethods